import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Directive, ElementRef, Renderer2, Input, ComponentFactory, ComponentRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';

@Directive({
  selector: '[imageLoader]',
})
export class LoadImageDirective {
  private spinnerFactory: ComponentFactory<MatProgressSpinner>;
  private spinner: ComponentRef<MatProgressSpinner>;

  @Input() backgroundSrc: string = null;

  constructor(private renderer: Renderer2, private el: ElementRef, private componentFactoryResolver: ComponentFactoryResolver, private viewContainerRef: ViewContainerRef) {
    this.spinnerFactory = this.componentFactoryResolver.resolveComponentFactory(MatProgressSpinner);
  }

  ngOnInit() {

    var img = new Image();

    /// set handler and url
    img.onload = ()=>{
      this.setImage();
      this.destroySpinner();
    };
    img.src = this.backgroundSrc;
    this.createSpinner();
  }

  private createSpinner(): void {
    if (!this.spinner) {
      this.spinner = this.viewContainerRef.createComponent(this.spinnerFactory);
      this.spinner.instance.diameter = 20;
      this.spinner.instance.mode = 'indeterminate';
      this.renderer.appendChild(this.el.nativeElement, this.spinner.instance._elementRef.nativeElement);
    }
  }

  private destroySpinner(): void {
    if (this.spinner) {
      this.spinner.destroy();
      this.spinner = null;
    }
  }

  private setImage = () => {
    this.renderer.setStyle(this.el.nativeElement,'background-image', 'url('+this.backgroundSrc+')');
  }
}
